export const countMilliseconds = (time: string) => {
  if (!time) {
    return;
  }

  const timeArr = time.split(':');
  const mins = Number.parseInt(timeArr[0]);
  const secs = Number.parseInt(timeArr[1]);

  return mins * 60000 + secs * 1000;
};
